import { IBaseModel } from "../base.model";

export interface IApartmentListingViewModel extends IBaseModel {
  apartment?: any;
  tenants?: any[]
  owners?: any[]
  caretakers?: any[]
  block?: any;
  location_number?: string;
}
export class ApartmentListingViewModel { }


// WEBPACK FOOTER //
// ./src/models/apartment/apartment-listing.viewmodel.ts